import { Popover as PopoverPrimitive } from "@base-ui/react/popover";

import { cn } from "@lib/utils";

/**Displays rich content in a portal, triggered by a button.*/
const Popover = ({ ...props }: PopoverPrimitive.Root.Props) => <PopoverPrimitive.Root data-slot="popover" {...props} />;

const PopoverTrigger = ({ ...props }: PopoverPrimitive.Trigger.Props) => (
	<PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
);

/**
 * @prop className - The class name to apply to the popover content
 * @prop align - The alignment of the popover content
 * @prop alignOffset - The offset of the popover content
 * @prop side - The side of the popover content
 * @prop sideOffset - The offset of the popover content
 */
const PopoverContent = ({
	className,
	align = "center",
	alignOffset = 0,
	side = "bottom",
	sideOffset = 4,
	...props
}: PopoverPrimitive.Popup.Props &
	Pick<PopoverPrimitive.Positioner.Props, "align" | "alignOffset" | "side" | "sideOffset">) => (
	<PopoverPrimitive.Portal>
		<PopoverPrimitive.Positioner
			align={align}
			alignOffset={alignOffset}
			side={side}
			sideOffset={sideOffset}
			className="isolate z-sticky"
		>
			<PopoverPrimitive.Popup
				data-slot="popover-content"
				className={cn(
					`text-popover-foreground ring-foreground/10 z-sticky flex w-72 origin-(--transform-origin) flex-col gap-2.5
					rounded-lg bg-block p-3 text-sm shadow-[0_2px_20px_0_rgba(0,0,0,0.90)] outline-hidden duration-100
					data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 data-open:animate-in
					data-open:fade-in-0 data-open:zoom-in-95 data-[side=bottom]:slide-in-from-top-2
					data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2
					data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2
					data-[side=top]:slide-in-from-bottom-2`,
					className,
				)}
				{...props}
			/>
		</PopoverPrimitive.Positioner>
	</PopoverPrimitive.Portal>
);

Popover.displayName = "Popover";
PopoverContent.displayName = "PopoverContent";
PopoverTrigger.displayName = "PopoverTrigger";

export { Popover, PopoverContent, PopoverTrigger };
